// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setInitialValues from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetInitialValues";
import { getCurrentEditingUser, hasChanges } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import HistoryContext from "@insite/mobius/utilities/HistoryContext";
import constants from "@store/constants";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

/* Store Custom Code - Start */
import updateLoadMaintenanceInfoParameter from "@insite/client-framework/Store/Pages/BudgetManagement/Handlers/UpdateLoadMaintenanceInfoParameter";
import updateMaintenanceInfo from "@insite/client-framework/Store/Pages/BudgetManagement/Handlers/UpdateMaintenanceInfo";
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    editingUser: getCurrentEditingUser(state),
    hasChanges: hasChanges(state),
});

const mapDispatchToProps = {
    setInitialValues,
    // Store Custom Code
    updateMaintenanceInfo,
    updateLoadMaintenanceInfoParameter,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface UserSetupSubmitStyles {
    saveButton?: ButtonPresentationProps;
    cancelButton?: ButtonPresentationProps;
}

export const userSetupSubmitStyles: UserSetupSubmitStyles = {
    cancelButton: { variant: "secondary" },
};

const styles = userSetupSubmitStyles;

const UserSetupSubmit = ({
    editingUser,
    hasChanges,
    setInitialValues,
    // Store Custom Code
    updateMaintenanceInfo,
    updateLoadMaintenanceInfoParameter,
}: Props) => {
    const cancelPageLink = usePageLinkByPageType(constants.pageType.userList);
    const { history } = useContext(HistoryContext);

    if (!editingUser) {
        return null;
    }

    const onCancelClick = () => {
        /* Store Custom Code - Start */
        updateMaintenanceInfo({ value: undefined });
        updateLoadMaintenanceInfoParameter({ fiscalYear: new Date().getFullYear() });
        /* Store Custom Code - End */

        if (hasChanges) {
            setInitialValues({ userId: editingUser.id });
        }
        if (cancelPageLink) {
            history.push(cancelPageLink.url);
        }
    };

    return (
        <FormActions>
            <Button {...styles.saveButton} type="submit" data-test-selector="userSetupHeader_saveButton">
                {translate("Save")}
            </Button>
            {cancelPageLink?.url ? (
                <Button
                    {...styles.cancelButton}
                    type="button"
                    onClick={onCancelClick}
                    data-test-selector="userSetupHeader_cancelButton"
                >
                    {translate("Cancel")}
                </Button>
            ) : null}
        </FormActions>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(UserSetupSubmit),
    definition: {
        group: "User Setup",
        displayName: "Submit",
        allowedContexts: ["UserSetupPage"],
    },
};

export default widgetModule;
